import { useMemo } from 'react'
import { useWallets } from './use-wallets'

export const useChainIds = () => {
  const { evm } = useWallets()
  return useMemo(() => {
    return [...new Set([evm?.chainId].filter((i) => i !== undefined))]
  }, [evm?.chainId])
}
